import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { process, whyUs } from "../mock";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export function Process() {
  return (
    <section id="process" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="eyebrow mb-4">HOW WE WORK</p>
          <h2 className="heading-2 mb-4">A Structured Process</h2>
          <p className="text-body text-lg">From your first brief through to post-show dismantling.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {process.map((p, i) => (
            <div key={i} className="relative pl-1">
              <div className="flex items-baseline gap-3 mb-3">
                <span className="font-display font-bold text-3xl text-brand">{p.num}</span>
                <span className="h-px flex-1 bg-gray-200" />
              </div>
              <h3 className="font-display font-semibold text-charcoal text-xl mb-2">{p.title}</h3>
              <p className="text-body">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function WhyUs() {
  return (
    <section id="why" className="section-pad bg-soft">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <p className="eyebrow mb-4">WHY RAINBOW WORLDWIDE</p>
          <h2 className="heading-2 mb-8">{whyUs.heading}</h2>
          <ul className="space-y-4 mb-8">
            {whyUs.points.map((pt, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 w-6 h-6 rounded-full bg-brand-soft flex items-center justify-center">
                  <Check className="text-brand" size={15} strokeWidth={3} />
                </span>
                <span className="text-charcoal leading-relaxed">{pt}</span>
              </li>
            ))}
          </ul>
          <p className="text-body mb-9">{whyUs.body}</p>
          <button onClick={() => scrollTo("contact")} className="btn-primary">
            Discuss Your Stand <ArrowRight size={18} />
          </button>
        </div>
        <div>
          <img
            src={whyUs.image}
            alt="Busy exhibition hall during a trade show"
            className="w-full h-[380px] lg:h-[480px] object-cover rounded-2xl shadow-md"
          />
        </div>
      </div>
    </section>
  );
}
